import { Col, Row } from 'reactstrap';
import CameraIcon from "./assets/camera-transparent.png";
import MagnifierIcon from "./assets/magnifier-transparent.png";
import MoneyBagIcon from "./assets/money-bag-transparent.png";

function ForHomeowners() {
  return (
    <div>
      <Row>
        <div className='text-center'>
          <h2 className={`display-5 fw-bold font-noto-serif`}>For Homeowners</h2>
        </div>
      </Row>
      <Row className='mt-2'>
        <Col xs="2" className='align-content-center text-start gx-0'>
          <img className='w-75 ms-2' src={CameraIcon} alt="Camera Icon"/>
        </Col>
        <Col xs="10" className='text-center'>
          <p className='font-helvetica-world'>
            <b>Create Your Project</b><br/>
            Snap a photo of your space or upload
            one from your gallery. Tell us what
            you want "modern kitchen",
            "country bathroom" or "under $5K refresh".
            Our Al instantly generates design ideas and a bill of materials
          </p>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col xs="2" className='align-content-center text-start gx-0'>
          <img className='w-75 ms-2' src={MagnifierIcon} alt="Magnifier Icon"/>
        </Col>
        <Col xs="10" className='text-center'>
          <p className='font-helvetica-world'>
            <b>Connect With a Contractor</b><br/>
            Browse verified local contractors
            who match your project scope and budget.
            Review ratings, timelines,and previous work before sending an offer
          </p>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col xs="2" className='align-content-center text-start gx-0'>
          <img className='w-75 ms-2' src={MoneyBagIcon} alt="Money Bag Icon"/>
        </Col>
        <Col xs="10" className='text-center'>
          <p className='font-helvetica-world'>
            <b>Lock In With a Smart Contract</b><br/>
            Your payment is held safely in
            BUILDE's crypto-powered escrow.
            Contractors know the funds are secured
          </p>
        </Col>
      </Row>
    </div>
  );
}

export default ForHomeowners;
